<template>
  <div class="settings-card">
    <div class="card-header">
      <h3><i class="fas fa-boxes"></i> Cấu hình Kho hàng</h3>
    </div>
    <div class="card-body">
      <div class="settings-list">
        <div class="form-group mb-4">
          <label>Phương pháp tính giá vốn</label>
          <select v-model="localData.costMethod" @change="update" class="form-control">
            <option value="fifo">Nhập trước - Xuất trước (FIFO)</option>
            <option value="lifo">Nhập sau - Xuất trước (LIFO)</option>
            <option value="average">Bình quân gia quyền (Average)</option>
          </select>
        </div>

        <div class="setting-item">
          <div class="setting-info">
            <label>Cảnh báo tồn kho thấp</label>
            <p>Thông báo khi số lượng sản phẩm xuống dưới ngưỡng thiết lập</p>
          </div>
          <van-switch v-model="localData.lowStockAlert" @input="update" size="24px" />
        </div>

        <div class="form-group mb-4" v-if="localData.lowStockAlert">
          <label>Ngỡng cảnh báo mặc định</label>
          <input type="number" v-model.number="localData.lowStockThreshold" @change="update" class="form-control" placeholder="Ví dụ: 10">
        </div>

        <div class="setting-item">
          <div class="setting-info">
            <label>Cho phép điều chỉnh kho thủ công</label>
            <p>Cho phép nhân viên kho thay đổi số lượng tồn kho mà không qua vận đơn</p>
          </div>
          <van-switch v-model="localData.allowManualStockAdjust" @input="update" size="24px" />
        </div>

        <div class="setting-item">
          <div class="setting-info">
            <label>Tự động trừ kho khi tạo đơn</label>
            <p>Hệ thống tự động cập nhật tồn kho ngay sau khi đơn hàng được lưu</p>
          </div>
          <van-switch v-model="localData.autoDeductStockOnOrder" @input="update" size="24px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data() {
    return {
      localData: JSON.parse(JSON.stringify(this.data))
    }
  },
  watch: {
    data: {
      handler(val) {
        this.localData = JSON.parse(JSON.stringify(val));
      },
      deep: true
    }
  },
  methods: {
    update() {
      this.$emit('update', 'inventory', this.localData);
    }
  }
}
</script>
